import {useContext} from 'react'

import {ModalsContext} from '../contexts/ModalsContext'

export const useModalsContext = () => {
  return useContext(ModalsContext)
}
